// import deepExtend from './../utilities/deepExtend.js';
import closestParent from './../utilities/closestParent.js';
import { screens } from '../../globals.js';

export default function ScrollTo() {
  return {
    init: () => {
      document.addEventListener('click', (event) => {
        const target = closestParent(
          event.target,
          'a[href^="#"]:not([href="#"]):not([data-w-noscrollto]), button[data-w-scrollto]'
        );
        if (target) {
          event.preventDefault();

          // remove open menu in any case
          // document.documentElement.classList.remove(
          //     'w-has-menu-open'
          // );
          // const closeMenuEvent = new CustomEvent(
          //     'w.FixedMenuHandler.close'
          // );
          // document.dispatchEvent(closeMenuEvent);

          const scrollTarget = document.querySelector(
            target.hasAttribute('data-w-scrollto')
              ? target.getAttribute('data-w-scrollto')
              : target.getAttribute('href')
          );
          if (scrollTarget) {
            const delay = target.hasAttribute('data-w-scrollto-delay')
              ? parseInt(target.getAttribute('data-w-scrollto-delay'))
              : 0;

            if (target.hasAttribute('data-w-scrollto-mq')) {
              const mqAttr = target.getAttribute('data-w-scrollto-mq');
              const breakpoint = mqAttr.split('-').pop();
              if (!screens[breakpoint]) return;

              const width = screens[breakpoint] * 16;
              const query =
                (mqAttr.includes('max') ? '(max-width: ' : '(min-width: ') +
                width +
                'px)';

              if (!window.matchMedia(query).matches) return;
            }

            setTimeout(() => {
              scrollTarget.scrollIntoView({
                behavior: 'smooth',
              });
            }, delay);
          }
        }
      });
    },
  };
}
